import type {
  FileScanStatus,
  KnowledgeKind,
  KnowledgeScope,
  KnowledgeSourceRefType,
  KnowledgeSourceType,
} from '../contracts/knowledge';

/** Rodzaje wiedzy (MVP §8: notatka, decyzja, link, plik). */
export const KNOWLEDGE_KIND_LABELS: Record<KnowledgeKind, string> = {
  note: 'Notatka',
  decision: 'Decyzja',
  link: 'Link',
  file: 'Plik',
};

export const KNOWLEDGE_KIND_PLURAL_LABELS: Record<KnowledgeKind, string> = {
  note: 'Notatki',
  decision: 'Decyzje',
  link: 'Linki',
  file: 'Pliki',
};

/** Zakres wiedzy (Figma 10: grupy „Fravity”, klient, projekt). */
export const KNOWLEDGE_SCOPE_LABELS: Record<KnowledgeScope, string> = {
  workspace: 'Firma',
  client: 'Klient',
  project: 'Projekt',
};

export const KNOWLEDGE_SOURCE_TYPE_LABELS: Record<KnowledgeSourceType, string> = {
  manual: 'Ręcznie',
  meeting: 'Spotkanie',
  message: 'Wiadomość',
  agent_run: 'Przebieg agenta',
  offer: 'Oferta',
  service: 'Usługa',
};

export const FILE_SCAN_STATUS_LABELS: Record<FileScanStatus, string> = {
  pending: 'Sprawdzanie',
  clean: 'Sprawdzony',
  infected: 'Zablokowany',
  skipped: 'Nie sprawdzono',
};

/** Rodzaj rekordu źródłowego w `source_ref` (link „źródło” przy decyzji i notatce). */
export const KNOWLEDGE_SOURCE_REF_LABELS: Record<KnowledgeSourceRefType, string> = {
  knowledge_item: 'Notatka',
  meeting: 'Spotkanie',
  message: 'Wiadomość',
  agent_run: 'Przebieg agenta',
  offer: 'Oferta',
  service: 'Usługa',
  task: 'Zadanie',
};

/** Kto widzi rekord wiedzy (linia meta notatki, Figma 10: „widzi: …”). */
export const KNOWLEDGE_SCOPE_AUDIENCE: Record<KnowledgeScope, string> = {
  workspace: 'cała firma',
  client: 'osoby z dostępem do klienta',
  project: 'osoby z dostępem do projektu',
};
